import { extendObservable, computed, action } from 'mobx'
import { clientContactApi } from '@atheneum/api'

class ClientContactStore {
  constructor (staticData, growlStore, clientContactSearchStore) {
    extendObservable(this, {
      staticData,
      growlStore,
      clientContactSearchStore,
      loading: false,
      error: null,
      contact: null,
      projects: [],
      projectCount: null,
      projectsPage: 1,
      projectsLoading: false,
      phones: computed(() => {
        if (this.contact) {
          return this.contact.address
            ? this.contact.address.phones.map(phone => {
                const phoneId = phone.phoneTypeId
                const phoneType = this.staticData.names.phoneTypes[phoneId]
                return { ...phone, phoneType }
              })
            : []
        }
      })
    })
  }

  getContact = id => {
    this.loading = true
    return clientContactApi.getClientContact(id).then(data => {
      if (data.address) {
        const { countryId, timezoneId } = data.address
        const { countries, timezones } = this.staticData.names
        const country = countries[countryId]
        const timezone = timezones[timezoneId]
        this.contact = {
          ...data,
          country,
          timezone
        }
      } else {
        this.contact = data
      }

      this.loading = false
    })
  }

  getProjects = (page = 1) => {
    this.projectsLoading = true
    return clientContactApi.getClientProjects(this.contact.id, page)
      .then(data => {
        this.projectCount = data.total
        const formattedData = data.rows.map(row => {
          const statusId = row.projectStatusId
          const status = this.staticData.names.projectStatuses[statusId]
          return { ...row, projectStatus: status }
        })
        this.projectsPage = page
        this.projects.replace(formattedData)
        this.projectsLoading = false
      })
      .catch(err => {
        this.error = err
      })
  }

  getProjectCount = id => {
    return clientContactApi.getClientProjectCount(id).then(({ count }) => {
      this.projectCount = count
    })
  }

  deleteClientContact = action(clientId => {
    return clientContactApi.deleteClientContact(clientId)
      .then(() => {
        return (
          this.clientContactSearchStore &&
          this.clientContactSearchStore.search()
        )
      })
      .catch(err => {
        this.error = err
        throw err
      })
  })
}

export default ClientContactStore
